
const getModuleState = state => state.cap17drive;

export const getSelectedSerie = state => getModuleState(state).selectedSerie;

export const getSelectedSeason = state => getModuleState(state).selectedSeason;

export const getSelectedEpisode = state => getModuleState(state).selectedEpisode;

export const getSelectedSeasonNumber = state => getModuleState(state).selectedSeason?.season_number ?? 1;
